import React from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { LiaBlogSolid } from "react-icons/lia";
import { FaUser } from "react-icons/fa";
import Tooltip from "@mui/material/Tooltip";
import { useMyContext } from "../../store/ContextApi";
import { TbBrandBooking } from "react-icons/tb";
import LocalCarWashIcon from "@mui/icons-material/LocalCarWash";
import StarIcon from "@mui/icons-material/Star";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { GiWallet } from "react-icons/gi";
import HeartBrokenIcon from "@mui/icons-material/HeartBroken";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import AlarmIcon from "@mui/icons-material/Alarm";
import SettingsIcon from "@mui/icons-material/Settings";
import HomeWorkIcon from "@mui/icons-material/HomeWork";

const Sidebar = () => {
  // Access the openSidebar and setOpenSidebar function using the useMyContext hook from the ContextProvider
  const { openSidebar, setOpenSidebar } = useMyContext();

  //access the current path
  const pathName = useLocation().pathname;

  return (
    <div
      className={`fixed p-2 top-[74px] min-h-[calc(100vh-74px)] max-h-[calc(100vh-74px)]  z-20  left-0 bg-headerColor ${
        openSidebar ? "w-52" : "w-12"
      } transition-all duration-150  `}
    >
      <div className=" min-h-10  max-h-10 flex flex-end">
        {openSidebar ? (
          <button
            className="flex w-full text-white justify-end items-center gap-1"
            onClick={() => setOpenSidebar(!openSidebar)}
          >
            <span>
              <FaArrowLeft className="text-sm" />
            </span>
            <span className="font-semibold">Close</span>
          </button>
        ) : (
          <Tooltip title="Click To Expand">
            <button
              className="flex w-full text-white justify-center items-center gap-1"
              onClick={() => setOpenSidebar(!openSidebar)}
            >
              <span>
                <FaArrowRight className="text-lg" />
              </span>
            </button>
          </Tooltip>
        )}
      </div>

      <div className="flex flex-col gap-5 mt-4">
        <Tooltip title={`${openSidebar ? "" : "Bookings"}`}>
          <Link
            to="/admin/all-bookings"
            className={`flex text-white items-center gap-2 ${
              pathName.startsWith("/admin/all-bookings")
                ? "bg-btnColor"
                : "bg-transparent"
            }   min-h-10 max-h-10 py-2 px-2 rounded-md hover:bg-btnColor`}
          >
            <span>
              <TbBrandBooking className="text-xl" />
            </span>
            <span
              className={` ${
                !openSidebar ? "opacity-0" : ""
              } transition-all font-semibold duration-150  ease-in-out`}
            >
              Bookings
            </span>
          </Link>
        </Tooltip>
        <Tooltip title={`${openSidebar ? "" : "Wash List"}`}>
          <Link
            to="/admin/wash-list"
            className={`flex text-white items-center gap-2 ${
              pathName.startsWith("/admin/wash-list")
                ? "bg-btnColor"
                : "bg-transparent"
            }   min-h-10 max-h-10 py-2 px-2 rounded-md hover:bg-btnColor`}
          >
            <span>
              <LocalCarWashIcon className="text-xl" />
            </span>
            <span
              className={` ${
                !openSidebar ? "opacity-0" : ""
              } transition-all font-semibold duration-150  ease-in-out`}
            >
              Wash List
            </span>
          </Link>
        </Tooltip>
        {/* <Tooltip title={`${openSidebar ? "" : "Rating"}`}>
          <Link
            to="/admin/review-list"
            className={`flex text-white items-center gap-2 ${
              pathName.startsWith("/admin/review-list")
                ? "bg-btnColor"
                : "bg-transparent"
            }   min-h-10 max-h-10 py-2 px-2 rounded-md hover:bg-btnColor`}
          >
            <span>
              <StarIcon className="text-xl" />
            </span>
            <span
              className={` ${
                !openSidebar ? "opacity-0" : ""
              } transition-all font-semibold duration-150  ease-in-out`}
            >
              Reviews
            </span>
          </Link>
        </Tooltip> */}
        <Tooltip title={`${openSidebar ? "" : "Recent Users"}`}>
          <Link
            to="/admin/recent-users"
            className={`flex text-white items-center gap-2 ${
              pathName.startsWith("/admin/recent-users")
                ? "bg-btnColor"
                : "bg-transparent"
            }   min-h-10 max-h-10 py-2 px-2 rounded-md hover:bg-btnColor`}
          >
            <span>
              <PeopleAltIcon className="text-xl" />
            </span>
            <span
              className={` ${
                !openSidebar ? "opacity-0" : ""
              } transition-all font-semibold duration-150  ease-in-out`}
            >
              Recent Users
            </span>
          </Link>
        </Tooltip>
        {/* <Tooltip title={`${openSidebar ? "" : "Estimated Price"}`}>
          <Link
            to="/admin/estimated-price"
            className={`flex text-white items-center gap-2 ${
              pathName.startsWith("/admin/estimated-price")
                ? "bg-btnColor"
                : "bg-transparent"
            }   min-h-10 max-h-10 py-2 px-2 rounded-md hover:bg-btnColor`}
          >
            <span>
              <CurrencyRupeeIcon className="text-xl" />
            </span>
            <span
              className={` ${
                !openSidebar ? "opacity-0" : ""
              } transition-all font-semibold duration-150  ease-in-out`}
            >
              Estimated Price
            </span>
          </Link>
        </Tooltip> */}
        <Tooltip title={`${openSidebar ? "" : "Expenses"}`}>
          <Link
            to="/admin/expenses"
            className={`flex text-white items-center gap-2 ${
              pathName.startsWith("/admin/expenses")
                ? "bg-btnColor"
                : "bg-transparent"
            }   min-h-10 max-h-10 py-2 px-2 rounded-md hover:bg-btnColor`}
          >
            <span>
              <GiWallet className="text-xl" />
            </span>
            <span
              className={` ${
                !openSidebar ? "opacity-0" : ""
              } transition-all font-semibold duration-150  ease-in-out`}
            >
              Expenses
            </span>
          </Link>
        </Tooltip>
        <Tooltip title={`${openSidebar ? "" : "Centre Booking"}`}>
          <Link
            to="/admin/centre-booking"
            className={`flex text-white items-center gap-2 ${
              pathName.startsWith("/admin/centre-booking")
                ? "bg-btnColor"
                : "bg-transparent"
            }   min-h-10 max-h-10 py-2 px-2 rounded-md hover:bg-btnColor`}
          >
            <span>
              <HomeWorkIcon className="text-xl" />
            </span>
            <span
              className={` ${
                !openSidebar ? "opacity-0" : ""
              } transition-all font-semibold duration-150  ease-in-out`}
            >
              Centre Booking
            </span>
          </Link>
        </Tooltip>
        {/* <Tooltip title={`${openSidebar ? "" : "Expenses"}`}>
          <Link
            to="/admin/db-health-check"
            className={`flex text-white items-center gap-2 ${
              pathName.startsWith("/admin/db-health-check")
                ? "bg-btnColor"
                : "bg-transparent"
            }   min-h-10 max-h-10 py-2 px-2 rounded-md hover:bg-btnColor`}
          >
            <span>
              <HeartBrokenIcon className="text-xl" />
            </span>
            <span
              className={` ${
                !openSidebar ? "opacity-0" : ""
              } transition-all font-semibold duration-150  ease-in-out`}
            >
              DB Health Check
            </span>
          </Link>
        </Tooltip> */}
        <Tooltip title={`${openSidebar ? "" : "Expenses"}`}>
          <Link
            to="/admin/exception-logs"
            className={`flex text-white items-center gap-2 ${
              pathName.startsWith("/admin/exception-logs")
                ? "bg-btnColor"
                : "bg-transparent"
            }   min-h-10 max-h-10 py-2 px-2 rounded-md hover:bg-btnColor`}
          >
            <span>
              <ErrorOutlineIcon className="text-xl" />
            </span>
            <span
              className={` ${
                !openSidebar ? "opacity-0" : ""
              } transition-all font-semibold duration-150  ease-in-out`}
            >
              Exceptions
            </span>
          </Link>
        </Tooltip>
        <Tooltip title={`${openSidebar ? "" : "Booking Slot"}`}>
          <Link
            to="/admin/booking-slot"
            className={`flex text-white items-center gap-2 ${
              pathName.startsWith("/admin/booking-slot")
                ? "bg-btnColor"
                : "bg-transparent"
            }   min-h-10 max-h-10 py-2 px-2 rounded-md hover:bg-btnColor`}
          >
            <span>
              <AlarmIcon className="text-xl" />
            </span>
            <span
              className={` ${
                !openSidebar ? "opacity-0" : ""
              } transition-all font-semibold duration-150  ease-in-out`}
            >
              Booking Slot
            </span>
          </Link>
        </Tooltip>
        <Tooltip title={`${openSidebar ? "" : "Settings"}`}>
          <Link
            to="/admin/settings"
            className={`flex text-white items-center gap-2 ${
              pathName.startsWith("/admin/settings")
                ? "bg-btnColor"
                : "bg-transparent"
            }   min-h-10 max-h-10 py-2 px-2 rounded-md hover:bg-btnColor`}
          >
            <span>
              <SettingsIcon className="text-xl" />
            </span>
            <span
              className={` ${
                !openSidebar ? "opacity-0" : ""
              } transition-all font-semibold duration-150  ease-in-out`}
            >
              Settings
            </span>
          </Link>
        </Tooltip>
      </div>
    </div>
  );
};

export default Sidebar;
